import React from 'react';
import contactData from '../contact.json';

const Safety = () => {
  const { hero, quality, footer } = contactData;

  return (
    <main className="pt-[60px] min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-[300px] md:h-[400px] overflow-hidden">
        <img 
          src={hero.image} 
          alt="Safety Information"
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-transparent"></div>
        <div className="absolute inset-0 flex items-center">
          <div className="container mx-auto px-6">
            <p className="text-white/80 text-xs font-bold tracking-[0.2em] mb-2">SAFETY INFORMATION</p>
            <h1 className="text-3xl md:text-4xl font-bold text-white mb-2">Safety Data</h1>
            <p className="text-xl text-white/90">安全信息</p>
          </div>
        </div>
      </section>

      {/* Safety Info Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <h2 className="text-2xl font-bold text-gray-900 mb-8">
            Safety Data Sheets
          </h2>
          
          <div className="space-y-8">
            <div className="bg-gray-50 p-8 rounded-lg">
              <h3 className="text-xl font-bold text-gray-900 mb-4">Safety Information</h3>
              <p className="text-gray-600 mb-6">
                We are committed to providing comprehensive safety information for all our products. 
                Please find below the safety data sheets for our main product categories.
              </p>
              <div className="space-y-4">
                <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg hover:bg-gray-100 transition-colors">
                  <span className="text-gray-800 font-medium">Silanol Products SDS</span>
                  <button className="bg-[#1a5681] text-white px-4 py-2 text-sm font-bold hover:bg-[#164a6d] transition-colors">
                    Download
                  </button>
                </div>
                <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg hover:bg-gray-100 transition-colors">
                  <span className="text-gray-800 font-medium">Silicone Oil SDS</span>
                  <button className="bg-[#1a5681] text-white px-4 py-2 text-sm font-bold hover:bg-[#164a6d] transition-colors">
                    Download
                  </button>
                </div>
                <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg hover:bg-gray-100 transition-colors">
                  <span className="text-gray-800 font-medium">Chemical Additives SDS</span>
                  <button className="bg-[#1a5681] text-white px-4 py-2 text-sm font-bold hover:bg-[#164a6d] transition-colors">
                    Download
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Quality Assurance */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-12">
            <p className="text-[#1a5681] text-xs font-bold tracking-[0.2em] mb-2">{quality.tag.en}</p>
            <h2 className="text-3xl font-bold text-gray-900 mb-4">{quality.title.en}</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">{quality.title.zh}</p>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {quality.certifications.map((cert, index) => (
              <div key={index} className="bg-white p-6 rounded-lg shadow-sm text-center hover:shadow-md transition-shadow">
                <span className="text-2xl font-bold text-[#1a5681]">{cert}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-50 py-8 border-t border-gray-200">
        <div className="container mx-auto px-6">
          <div className="flex flex-col items-center justify-center gap-4">
            <p className="text-gray-400 text-xs text-center">{footer.copyright}</p>
            <p className="text-gray-400 text-xs text-center">
              <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" className="hover:underline">
                {footer.beian}
              </a>
            </p>
          </div>
        </div>
      </footer>
    </main>
  );
};

export default Safety;